import * as React from 'react';
import classNames from 'classnames';
import style from './text-field.scss';
import {Flex} from '../Flex';
import {Text} from '../Text';

export interface TextFieldProps {
  label?: string;
  value: string;
  error?: string;
  helpText?: string;
  touched?: boolean;
}

type InputProps = JSX.IntrinsicElements['input'];

export function TextField({
  id,
  label,
  value,
  error,
  touched = false,
  helpText,
  className,
  ...restProps
}: TextFieldProps & InputProps) {

  const showHelp = Boolean(helpText);
  const showError = Boolean(touched && error);
  const showLabel = Boolean(label);

  /* eslint-disable jsx-a11y/label-has-for */
  return (
    <Flex
      direction="column"
      className={classNames(style.wrap, className, {
        [style.error]: touched && error,
      })}
    >
      {showLabel && (
        <label className={style.label} htmlFor={id}>
          <Text text={String(label)} />
        </label>
      )}
      <input id={id} className={style.input} {...restProps} />
      {showError && <span className={style.error}>{error}</span>}
      {showHelp && <span className={style.help}>{helpText}</span>}
    </Flex>
  );
  /* eslint-enable */
}
